/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, March 2020
 */

/**
 * Analyitcs.
 */
export const AUTOLOGIN_EVENT_ACTION = 'Inicia sesión';
export const AUTOLOGIN_EVENT_CATEGORY = 'Home';
export const AUTOLOGIN_EVENT_LABEL = 'Usuario y contraseña';
export const AUTOLOGIN_EVENT_SUCCESS_LABEL = 'Exitoso Usuario y contraseña';
export const AUTOLOGIN_EVENT_ERROR_LABEL_PREFIX = 'InicioSesiónUsuarioYContraseña';

/**
 * Cintillo
 */
 export const ALERT_ACTION_DEFAULT = 1;
 export const ALERT_ACTION_IPTELMEX = 2;


// WEBPACK FOOTER //
// ./src/containers/App/constants.js